import { IJiraField } from '~/domain/IJiraField';

/**
 * Get full name of JIRA keys/names be adding prefix and dash
 * @param name
 */
export const getFullName = (name: string, jiraPrefix: string) => `${jiraPrefix} - ${name}`

export const mapField = (fields: IJiraField[], fieldName: string, jiraPrefix: string) => {
  return fields.find(field => field.name === getFullName(fieldName, jiraPrefix));
}
